/**
 * orga-app-api - kontaktverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface KontaktAktiv { 
    ist_aktiv?: boolean;
    funktionsbereich_id: string;
    kontakt_id: string;
    mandant_id: string;
    modified_on_utc?: Date;
    modified_user_id?: string;
}

